import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { termsLoader } from "managers/staticDataManager";
import { TERMS_REFRESH_INTERVAL_IN_MILISECUNDES } from "config";

const TermsRefresh = (params) => {

    const dispatch = useDispatch();
    const termsInitializationTime = useSelector((state) => state.staticData.termsInitializationTime);

    React.useEffect(() => {
        let result = Date.now() - termsInitializationTime;
        // console.log('TermsRefresh: result, TERMS_REFRESH_INTERVAL_IN_MILISECUNDES: ', result, TERMS_REFRESH_INTERVAL_IN_MILISECUNDES);
        if(result > TERMS_REFRESH_INTERVAL_IN_MILISECUNDES) {
            // console.log('TermsRefresh: loadTerms');
            loadTerms();
        }
    }, [params?.match?.params?.layouts]);
    
    const loadTerms = () => {
        termsLoader(dispatch);
    };

    return (
        <>
        </>
    )
};

export default TermsRefresh;